import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Dropdown, ProgressBar } from "react-bootstrap";
import ArrowDown from "../Assets/Images/ArrowDown";
import { useNavigate } from "react-router-dom";
import { CircleCross } from "../Assets/Images/CircleCross";
import { InputComponent, OptionBtn, QuestionText } from "./styled";
import { BackIcon } from "../Assets/Images/BackIcon";
import { CountryInputComponent } from "../Component/CountryInputComponent";
import PhoneInput from "react-phone-number-input";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { getCountries } from "react-phone-number-input";
import { FormInput } from "../Component";
import { debounce } from "debounce";
import { searchCountries } from "../Services/Function";
import i18next, { t } from "i18next";

export default function CountryModal(props) {
  const [page, setPage] = useState("1");
  const [destination, setDestination] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [degree, setDegree] = useState({});
  const [majors, setMajors] = useState("");
  const [cgpa, setCgpa] = useState("");
  const [previousSchool, setPreviousSchool] = useState("");
  const [takenIelts, setTakenIelts] = useState(null);
  const [ieltsScore, setIeltsScore] = useState("");
  const [engLevel, setEngLevel] = useState("");
  const [phoneNo, setPhoneNo] = useState("");

  const [fullName, setFullName] = useState("");
  const [accomplished, setAccomplished] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [countries, setcountries] = useState([]);
  const [loading, setloading] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [checkQualified, setcheckQualified] = useState(false);
  const excludedCountries = ["IL"]; // Countries to exclude
  const filteredCountries = getCountries().filter(
    (country) => !excludedCountries.includes(country)
  );
  const [recommendedCountries, setrecommendedCountries] = useState([
    {
      english_name: "Kuwait",
      arabic_name: "الكويت",
      alpha2_code: "KW",
      alpha3_code: "KWT",
      phone_code: "965",
      id: "63cfb299df954c47a6fde217",
    },
    {
      english_name: "Saudi Arabia",
      arabic_name: "السعودية",
      alpha2_code: "SA",
      alpha3_code: "SAU",
      phone_code: "966",
      id: "63cfb299df954c47a6fde264",
    },
    {
      english_name: "Qatar",
      arabic_name: "قطر",
      alpha2_code: "QA",
      alpha3_code: "QAT",
      phone_code: "974",
      id: "63cfb299df954c47a6fde255",
    },
    {
      english_name: "Oman",
      arabic_name: "سلطنة عمان",
      alpha2_code: "OM",
      alpha3_code: "OMN",
      phone_code: "968",
      id: "63cfb299df954c47a6fde248",
    },
    {
      english_name: "United Arab Emirates",
      arabic_name: "الإمارات العربية المتحدة",
      alpha2_code: "AE",
      alpha3_code: "ARE",
      phone_code: "971",
      id: "63cfb299df954c47a6fde28d",
    },
  ]);

  const arabic = i18next.language === "ar";

  const navigate = useNavigate();

  const nextPage = (page) => {
    setPage(page);
  };

  const onChangeDestination = (data) => {
    setAccomplished((prev) => [...prev, "pageone"]);
    nextPage("2");
    setDestination(data);
  };

  const onChangeDegree = (data) => {
    setDegree(data);
  };

  const resetValues = () => {
    setAccomplished([]);
    setDestination({});
    setSelectedCountry({});
    setDegree({});
    setMajors("");
    setCgpa("");
    setPreviousSchool("");
    setTakenIelts(null);
    setIeltsScore("");
    setEngLevel("");
    setPhoneNo("");
    setFullName("");
    setErrorMessage("");
  };

  const setuserDatafn = (lvl) => {
    const userData = {
      destination,
      selectedCountry,
      degree,
      majors,
      cgpa,
      previousSchool,
      englishProficiency: takenIelts
        ? { hasTest: true, score: ieltsScore }
        : { hasTest: false, level: lvl },
    };

    navigate(props.query ? `/major-test${props.query}` : "/major-test", {
      state: {
        country: destination.ar_name,
        userData,
      },
    });
  };

  const contryCheckQualified = (country) => {
    return (
      country.english_name === "United States of America" ||
      country.english_name === "Australia" ||
      country.english_name === "Oman" ||
      country.english_name === "France" ||
      country.english_name === "Spain" ||
      country.english_name === "United Kingdom" ||
      country.english_name === "Qatar" ||
      country.english_name === "Kuwait" ||
      country.english_name === "Saudi Arabia" ||
      country.english_name === "United Arab Emirates" ||
      country.english_name === "Bahrain" ||
      country.english_name === "Germany"
    );
  };

  const searchCountry = debounce(async (e) => {
    if (!e.target.value) {
      setcountries([]);
    } else {
      setloading(true);
      const res = await searchCountries({
        text: e.target.value,
        sortBy: "createdAt:desc",
        limit: 7,
      });
      setcountries(res?.results);
      setloading(false);
    }
  }, 500);

  return (
    <Modal
      {...props}
      fullscreen={true}
      style={{ borderRadius: 0 }}
      // className="careerModal"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        resetValues();
        props.onHide();
      }}
    >
      <Modal.Header style={{ borderBottom: "none", width: "100%" }}>
        <Modal.Title className="w-100 d-flex justify-content-between align-items-center">
          {page === "1" ? (
            <div />
          ) : (
            <div
              className="d-flex align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPage(`${parseInt(page) - 1}`);
              }}
            >
              <BackIcon />
            </div>
          )}
          <ProgressBar now={parseInt(page) * 15} />
          <div
            onClick={() => {
              resetValues();
              props.onHide();
            }}
            className="d-flex align-items-center"
          >
            <CircleCross style={{ width: 28, height: 28, cursor: "pointer" }} />
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex justify-content-center align-items-center"
        style={{ overflow: "hidden" }}
      >
        {page === "1" ? (
          <div className="res-con-width">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              في أي بلد ترغب بالدراسة؟
            </QuestionText>
            <div className="d-flex flex-column justify-content-center w-100">
              <div
                className="d-flex flex-row w-100 justify-content-center"
                style={{
                  paddingBottom: 15,
                  direction: "rtl",
                }}
              >
                <OptionBtn
                  className="  "
                  arabic={true}
                  justifyContent="space-between"
                  style={{
                    color: destination.en_name === "UK" ? "#299cf7" : "#191d23",
                    backgroundColor:
                      destination.en_name === "UK" ? "#299cf714" : "#E8E9F5B2",
                    width: "100%",
                    direction: "rtl",
                    margin: "0px 0 0 20px",
                  }}
                  onClick={() => {
                    onChangeDestination({
                      ar_name: "بريطانيا",
                      en_name: "UK",
                    });
                  }}
                >
                  <div />
                  <div
                    style={{
                      fontSize: 24,
                      position: "relative",
                      left: 10,
                    }}
                  >
                    🇬🇧
                  </div>{" "}
                  بريطانيا
                </OptionBtn>
                <OptionBtn
                  className="  "
                  arabic={true}
                  justifyContent="space-between"
                  style={{
                    color: destination.en_name === "US" ? "#299cf7" : "#191d23",
                    backgroundColor:
                      destination.en_name === "US" ? "#299cf714" : "#E8E9F5B2",
                    width: "100%",
                    marginRight: 0,
                  }}
                  onClick={() =>
                    onChangeDestination({ ar_name: "أمريكا", en_name: "US" })
                  }
                >
                  <div />
                  <div
                    style={{
                      fontSize: 24,
                      position: "relative",
                      left: 10,
                    }}
                  >
                    🇺🇸
                  </div>{" "}
                  أمريكا
                </OptionBtn>
              </div>

              <div className="d-flex flex-row w-100 justify-content-center">
                <OptionBtn
                  className="  "
                  arabic={true}
                  justifyContent="space-between"
                  style={{
                    color:
                      destination.en_name === "Australia"
                        ? "#299cf7"
                        : "#191d23",
                    backgroundColor:
                      destination.en_name === "Australia"
                        ? "#299cf714"
                        : "#E8E9F5B2",
                    width: "100%",
                    direction: "rtl",
                    margin: "0px 20px 0 0",
                  }}
                  onClick={() =>
                    onChangeDestination({
                      ar_name: "أستراليا",
                      en_name: "Australia",
                    })
                  }
                >
                  <div />
                  <div
                    style={{
                      fontSize: 24,
                      position: "relative",
                      left: 10,
                    }}
                  >
                    🇦🇺
                  </div>{" "}
                  أستراليا
                </OptionBtn>

                <OptionBtn
                  className="  "
                  arabic={true}
                  justifyContent="space-between"
                  style={{
                    color:
                      destination.en_name === "Others" ? "#299cf7" : "#191d23",
                    backgroundColor:
                      destination.en_name === "Others"
                        ? "#299cf714"
                        : "#E8E9F5B2",
                    width: "100%",
                    marginRight: 0,
                    direction: "rtl",
                  }}
                  onClick={() =>
                    onChangeDestination({
                      ar_name: "غيرها",
                      en_name: "Others",
                    })
                  }
                >
                  <div />
                  <div
                    style={{
                      fontSize: 24,
                      position: "relative",
                      left: 10,
                    }}
                  >
                    🌏
                  </div>{" "}
                  غيرها
                </OptionBtn>
              </div>
            </div>
          </div>
        ) : page === "2" ? (
          <div className="res-con-width d-flex flex-column justify-content-center align-items-center">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              ما هي جنسيتك؟
            </QuestionText>
            <div style={{ width: "100%" }}>
              <CountryInputComponent
                selectedCountry={selectedCountry}
                loading={loading}
                setsearchText={setsearchText}
                setselectedCountry={setSelectedCountry}
                arabic={arabic}
                onClickNext={() => {
                  if (selectedCountry) {
                    accomplished.push("pagetwo");
                    nextPage("3");
                    // seterrorMessage("");
                    setcountries([]);
                    setsearchText("");

                    setcheckQualified(contryCheckQualified(selectedCountry));
                  } else {
                    setErrorMessage("Select country to continue");
                  }
                }}
                recommendedCountries={recommendedCountries.slice(0, 5)}
                searchCountry={searchCountry}
                countries={countries}
                setcountries={(a) => setcountries(a)}
                searchText={searchText}
                placeholder={`${t("common:nationalityPlaceholder")}`}
                setRecommendedCountries={setrecommendedCountries}
              />

              {/* {errorMessage ? (
                <ErrorMessage>{errorMessage}</ErrorMessage>
              ) : null} */}
            </div>
          </div>
        ) : page === "3" ? (
          <div className="res-con-width d-flex flex-column justify-content-center align-items-center">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              ما هي الدرجة التي تريد الحصول عليها؟
            </QuestionText>
            <div
              className="d-flex flex-row w-100 justify-content-center"
              style={{
                paddingBottom: 15,
                direction: "rtl",
              }}
            >
              <OptionBtn
                className=" "
                justifyContent="center"
                arabic={true}
                style={{
                  color:
                    degree.en_name === "Bachelor's" ? "#299cf7" : "#191d23",
                  backgroundColor:
                    degree.en_name === "Bachelor's" ? "#299cf714" : "#E8E9F5B2",
                  width: "100%",
                  margin: "0px 0 0 20px",
                }}
                onClick={() => {
                  onChangeDegree({
                    en_name: "Bachelor's",
                    ar_name: "البكلوريوس",
                  });
                  setAccomplished((prev) => [...prev, "pagethree"]);
                  nextPage("4");
                }}
              >
                البكلوريوس
              </OptionBtn>
              <OptionBtn
                className=" "
                style={{
                  color: degree.en_name === "Master's" ? "#299cf7" : "#191d23",
                  backgroundColor:
                    degree.en_name === "Master's" ? "#299cf714" : "#E8E9F5B2",
                  width: "100%",
                  marginRight: 0,
                }}
                justifyContent="center"
                arabic={true}
                onClick={() => {
                  onChangeDegree({
                    en_name: "Master's",
                    ar_name: "الماجستير",
                  });

                  setAccomplished((prev) => [...prev, "pagethree"]);
                  nextPage("4");
                }}
              >
                الماجستير
              </OptionBtn>
            </div>
            <div
              style={{ direction: "rtl" }}
              className="d-flex flex-row w-100 justify-content-center"
            >
              <OptionBtn
                className=" "
                style={{
                  color: degree.en_name === "PhD" ? "#299cf7" : "#191d23",
                  backgroundColor:
                    degree.en_name === "PhD" ? "#299cf714" : "#E8E9F5B2",
                  width: "100%",
                  margin: "0",
                }}
                justifyContent="center"
                arabic={true}
                onClick={() => {
                  onChangeDegree({
                    en_name: "PhD",
                    ar_name: "الدكتوراة",
                  });
                  setAccomplished((prev) => [...prev, "pagethree"]);
                  nextPage("4");
                }}
              >
                الدكتوراة
              </OptionBtn>
            </div>
          </div>
        ) : page === "4" ? (
          <div className="res-con-width d-flex flex-column justify-content-center align-items-center">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              ما هو المعدل التراكمي أو النسبة المئوية؟
            </QuestionText>
            <div className="w-100">
              <InputComponent
                placeholder="أدخل معدلك"
                name="cgpa"
                onChange={(e) => setCgpa(e.target.value)}
                type="text"
                value={cgpa}
                arabic={true}
                autoComplete="off"
              />
              {cgpa ? null : (
                <div className="d-flex justify-content-center">
                  <OptionBtn
                    arabic={arabic}
                    style={{
                      marginTop: 20,
                      width: "max-content",
                      padding: "0 25px",
                    }}
                    onClick={() => {
                      setCgpa("غير متأكد");
                      setAccomplished((prev) => [...prev, "pagefour"]);
                      nextPage("5");
                    }}
                  >
                    غير متأكد
                  </OptionBtn>
                </div>
              )}
              {cgpa && cgpa !== "غير متأكد" && (
                <Button
                  style={{ width: 158, marginTop: 20 }}
                  className="custom-black-btn"
                  onClick={() => {
                    setAccomplished((prev) => [...prev, "pagefour"]);
                    nextPage("5");
                  }}
                >
                  استمر
                </Button>
              )}
            </div>
          </div>
        ) : page === "5" ? (
          <div className=" res-con-width d-flex flex-column justify-content-center align-items-center">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              ما هي المدرسة أو الجامعة السابقة؟
            </QuestionText>
            <div style={{ width: "100%" }}>
              <InputComponent
                placeholder="أدخل اسم المدرسة/الجامعة"
                name="previousSchool"
                onChange={(e) => setPreviousSchool(e.target.value)}
                type="text"
                value={previousSchool}
                arabic={true}
                autoComplete="off"
              />
              {previousSchool ? null : (
                <div className="d-flex justify-content-center">
                  <OptionBtn
                    style={{
                      marginTop: 20,
                      width: "max-content",
                      padding: "0 25px",
                    }}
                    onClick={() => {
                      setPreviousSchool("غير متأكد");
                      setAccomplished((prev) => [...prev, "pagefive"]);
                      nextPage("6");
                    }}
                    arabic={arabic}
                  >
                    غير متأكد
                  </OptionBtn>
                </div>
              )}
              {previousSchool && previousSchool !== "غير متأكد" && (
                <Button
                  style={{ width: 158, marginTop: 20 }}
                  className="custom-black-btn"
                  onClick={() => {
                    setAccomplished((prev) => [...prev, "pagefive"]);
                    nextPage("6");
                  }}
                >
                  استمر
                </Button>
              )}
            </div>
          </div>
        ) : page === "6" ? (
          <div className="res-con-width d-flex flex-column justify-content-center align-items-center">
            <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
              هل سبق لك أن حصلت على اختبار IELTS أو TOEFL؟
            </QuestionText>
            <div
              className="d-flex flex-row w-100 justify-content-center"
              style={{
                paddingBottom: 15,
                direction: "rtl",
              }}
            >
              <OptionBtn
                className=" "
                justifyContent="center"
                arabic={true}
                style={{
                  color: takenIelts === true ? "#299cf7" : "#191d23",
                  backgroundColor:
                    takenIelts === true ? "#299cf714" : "#E8E9F5B2",
                  width: "100%",
                  margin: "0px 0 0 20px",
                }}
                onClick={() => setTakenIelts(true)}
              >
                نعم
              </OptionBtn>
              <OptionBtn
                className=" "
                style={{
                  color: takenIelts === false ? "#299cf7" : "#191d23",
                  backgroundColor:
                    takenIelts === false ? "#299cf714" : "#E8E9F5B2",
                  width: "100%",
                  marginRight: 0,
                }}
                justifyContent="center"
                arabic={true}
                onClick={() => setTakenIelts(false)}
              >
                لا
              </OptionBtn>
            </div>
            {takenIelts === true ? (
              <div style={{ width: "100%", marginTop: 20 }}>
                <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
                  ما هي نتيجتك في IELTS أو TOEFL؟
                </QuestionText>
                <InputComponent
                  placeholder="أدخل نتيجتك"
                  name="ieltsScore"
                  onChange={(e) => setIeltsScore(e.target.value)}
                  type="text"
                  value={ieltsScore}
                  arabic={true}
                  autoComplete="off"
                />
                {ieltsScore && (
                  <div className="w-100 d-flex justify-content-center">
                    <Button
                      style={{ width: 158, marginTop: 20 }}
                      className="custom-black-btn"
                      onClick={() => {
                        setAccomplished((prev) => [...prev, "pagesix"]);
                        nextPage("7");
                        setuserDatafn();
                      }}
                    >
                      استمر
                    </Button>
                  </div>
                )}
              </div>
            ) : takenIelts === false ? (
              <div style={{ width: "100%", marginTop: 20 }}>
                <QuestionText arabic={arabic} style={{ textAlign: "center" }}>
                  ما هو مستواك في اللغة الإنجليزية؟
                </QuestionText>
                <div
                  style={{ direction: "rtl" }}
                  className="d-flex flex-column w-100"
                >
                  <div
                    className="d-flex flex-row w-100 justify-content-center"
                    style={{
                      paddingBottom: 15,
                      direction: "rtl",
                    }}
                  >
                    <OptionBtn
                      width="100%"
                      arabic={arabic}
                      style={{ margin: "0px 0px 10px 20px" }}
                      onClick={() => {
                        setEngLevel("beginner");
                        setAccomplished((prev) => [...prev, "pagesix"]);
                        nextPage("7");
                        setuserDatafn("beginner");
                      }}
                    >
                      مبتدئ
                    </OptionBtn>
                    <OptionBtn
                      width="100%"
                      arabic={arabic}
                      style={{ marginBottom: 10 }}
                      onClick={() => {
                        setEngLevel("lowerIntermediate");
                        setAccomplished((prev) => [...prev, "pagesix"]);
                        nextPage("7");
                        setuserDatafn("lowerIntermediate");
                      }}
                    >
                      متوسط منخفض
                    </OptionBtn>
                  </div>
                  <div
                    className="d-flex flex-row w-100 justify-content-center"
                    style={{
                      paddingBottom: 15,
                      direction: "rtl",
                    }}
                  >
                    <OptionBtn
                      width="100%"
                      arabic={arabic}
                      style={{ margin: "0px 0px 10px 20px" }}
                      onClick={() => {
                        setEngLevel("intermediate");
                        setAccomplished((prev) => [...prev, "pagesix"]);
                        nextPage("7");
                        setuserDatafn("intermediate");
                      }}
                    >
                      متوسط
                    </OptionBtn>
                    <OptionBtn
                      width="100%"
                      arabic={arabic}
                      style={{ marginBottom: "10" }}
                      onClick={() => {
                        setEngLevel("upperIntermediate");
                        setAccomplished((prev) => [...prev, "pagesix"]);
                        nextPage("7");
                        setuserDatafn("upperIntermediate");
                      }}
                    >
                      متوسط متقدم
                    </OptionBtn>
                  </div>
                  <OptionBtn
                    width="100%"
                    arabic={arabic}
                    onClick={() => {
                      setEngLevel("advanced");
                      setAccomplished((prev) => [...prev, "pagesix"]);
                      nextPage("7");
                      setuserDatafn("advanced");
                    }}
                  >
                    متقدم
                  </OptionBtn>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}
